import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children"];
import { useNumberOfFrozenColumns } from 'framework-listing-lib/internal/ViewTabs/hooks/useViewProps';
import { useListingLibBulkActions } from 'framework-listing-lib/internal/Table/providers/ListingLibBulkActionsProvider';
import { TableHoverCell } from 'foundations-components/transitional/components/Table';
import { MERCURY_LAYER, SUN_LAYER } from 'foundations-components/transitional/constants';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function ListingLibLabelCell(props) {
  const numberOfFrozenColumns = useNumberOfFrozenColumns();
  if (numberOfFrozenColumns && numberOfFrozenColumns > 0) {
    return /*#__PURE__*/_jsx(StickyListingLibLabelCellInner, Object.assign({}, props));
  }
  return /*#__PURE__*/_jsx(TableHoverCell, Object.assign({
    "data-test-id": "listing-lib-label-cell"
  }, props, {
    "data-sticky-cell": false,
    position: "relative"
  }));
}
function StickyListingLibLabelCellInner(_ref) {
  let {
      children
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    hasBulkActions
  } = useListingLibBulkActions();
  return /*#__PURE__*/_jsxs(TableHoverCell, Object.assign({
    "data-test-id": "listing-lib-label-cell"
  }, rest, {
    "data-sticky-cell": true
    // Styles from https://git.hubteam.com/HubSpot/customer-data-table/blob/79c4edfd7d31cb1a5b67b0e9c4e3b5b0ba673536/framework-data-table/static/js/contentRenderers/labels/LabelCell.tsx#L165-L173
    ,
    position: "sticky",
    insetBlockStart: "0px",
    insetInlineStart: hasBulkActions ? '44px' : '0px',
    zIndex: MERCURY_LAYER,
    children: [children, /*#__PURE__*/_jsx(View, {
      "data-test-id": "listing-lib-label-cell-border",
      display: "block",
      as: "span",
      position: "absolute",
      zIndex: SUN_LAYER,
      insetBlockEnd: "0",
      insetInlineEnd: "0",
      blockSize: "100%",
      inlineSize: "4px",
      backgroundColor: "border-core-subtle"
    })]
  }));
}